import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import swal from 'sweetalert2';
import { isNullOrUndefined } from 'util';

import { Products } from '../../product/models/product';
import { ProductService } from '../../product/product.service';
import { ServicesService } from '../../services/services.service';
import { OrderData } from '../models/order-data';

@Component({
  selector: 'app-view-all-orders',
  templateUrl: './view-all-orders.component.html'
})
export class ViewAllOrdersComponent implements OnInit {
  @Input() orderData: OrderData;
  @Output() viewOrder: EventEmitter<OrderData> = new EventEmitter<OrderData>();

  clientName: string;

  backDiv = false;

  headerFields: any[] = [
    {
      field: "order_no_unique",
      title: "Order No",
      width: "15%",
      code: true,
      sort: true,
    },
    {
      field: "client_name",
      title: "Client Name",
      width: "20%",
      code: true,
      sort: true,
    },
    {
      field: "order_date",
      title: "Order Date",
      width: "20%",
      code: false,
      sort: false,
    },
    {
      field: "order_status",
      title: "Order Status",
      width: "15%",
      code: false,
      sort: false,
    },
    {
      field: "loadsheet_no",
      title: "Loadsheet No.",
      width: "20%",
      code: false,
      sort: false,
    },
  ];

  currentPage: number = 1;
  loader: boolean = false;
  paginate = {
    last_page: 1,
  };
  searchFields = [];
  pages: any;
  editData: Object = {};

  orderProjectList: any;
  searchProjectId: any = "";
  listData: any = [];
  backOrder: any = [];
  total: any;
  productList: Products = [];

  isListData = true;
  isOnePage = true;
  isNoDataList = false;
  tokenStatus: any;
  cname: any;
  delorder;
  totalorder;
  sortType: string = "";
  sortField: string = "";
  oldField: string;
  sortingData = {
    field: "",
    type: "",
  };

  config = {
    displayKey: "project_name", //if objects array passed which key to be displayed defaults to description,
    search: true, //enables the search plugin to search in the list,
    limitTo: 5,
  };

  spinLoader = {
    filter: false,
    delete: [],
  };

  dataModel: any = {};
  isCid: boolean;

  constructor(private _services: ServicesService,
    private readonly productService: ProductService) {
  }

  ngOnInit(): void {
    this.isCid = !isNullOrUndefined(this.orderData.clientId) && this.orderData.clientId !== 0;
    this.getPageRequest();
    this.getOrderProjectList();
    //if client id is set in url form clientDashBoard...
    if (this.orderData.clientId != undefined) {
      // //console.log(this.cid);
      this.clientName = this.orderData.clientName;
      this.backDiv = true;
    }
  }

  getOrderProjectList() {
    const routeData = "get-project-order-list";
    const data = {
      page: this.currentPage,
      search: {
        project_name: this.searchFields["project_name"],
      },
    };
    const token = localStorage.getItem("userToken");
    this._services
      .requestCreator(data, routeData, token)
      .subscribe((result: any) => {
        if (this._services.checkToken(result.status)) {
          // //console.log(result.result);
          this.orderProjectList = result.result;
          // //console.log(this.orderProjectList);
        }
      });

    return true;
  }

  previousPage() {
    if (this.currentPage == 1) {
      return;
    }
    this.spinLoader["filter"] = true;
    this.currentPage = this.currentPage - 1;
    this.getPageRequest();
  }

  nextPage() {
    this.spinLoader["filter"] = true;
    if (this.paginate.last_page - 1 < this.currentPage) {
      return;
    }

    this.currentPage++;
    this.getPageRequest();
  }

  changePage() {
    this.spinLoader["filter"] = true;
    this.currentPage = this.currentPage;
    this.getPageRequest();
  }

  getPages(n) {
    if (n > 1) {
      this.isOnePage = true;
    } else {
      this.isOnePage = false;
    }
    var data = [];
    for (var i = 1; i <= n; i++) {
      data.push(i);
    }
    this.pages = data;
  }

  getSearchRequest() {
    this.spinLoader["filter"] = true;
    this.getPageRequest();
  }

  getPageRequest() {
    const routePath = "get-order-list-web";
    switch (routePath) {
      case "get-order-list-web":
        {
          var data = {
            page: this.currentPage,
            search: {
              client_name: this.searchFields["client_name"],
              order_no_unique: this.searchFields["order_no_unique"],
            },
            sort: this.sortingData,
            project_order_id: this.searchProjectId ? this.searchProjectId : "",
          };
        }
        break;
    }
    const token = localStorage.getItem("userToken");
    this._services
      .requestCreator(data, routePath, token)
      .subscribe((result: any) => {
        this._services.checkToken(result.status);
        this.spinLoader["filter"] = false;
        this.isListData = false;
        this.listData = result.result;
        this.delorder = result.delivered_order;
        this.totalorder = result.total_orders;
        this.listData == ""
          ? (this.isNoDataList = true)
          : (this.isNoDataList = false);

        if (result.backOrder) {
          this.backOrder = result.backOrder;
          //console.log("backorder", this.backOrder)
        }

        // //console.log(this.backOrder);
        this.paginate = result.paginate;
        this.currentPage = result.paginate.current_page;
        this.total = result.paginate.total;
        if (result.paginate.current_page > result.paginate.last_page) {
          this.currentPage = result.paginate.last_page;
        }
        this.getPages(this.paginate.last_page);
      });
    return true;
  }

  resetSearchField() {
    this.spinLoader["filter"] = true;
    this.searchFields = [""];
    this.searchProjectId = "";
    this.getPageRequest();
  }

  sortBy(field, event) {
    this.spinLoader["filter"] = true;
    this.oldField = this.oldField != field ? this.oldField : field;

    if (typeof this.oldField !== "undefined") {
      ////console.log(document.getElementById('fa-'+this.oldField));

      document
        .getElementById("fa-" + this.oldField)
        .classList.remove("fa-sort-up");
      document
        .getElementById("fa-" + this.oldField)
        .classList.remove("fa-sort-down");
      document.getElementById("fa-" + this.oldField).classList.add("fa-sort");
    }

    event.target.classList.add("fa");

    this.sortField = field;
    this.sortType = this.sortType == "desc" ? "asc" : "desc";

    switch (this.sortType) {
      case "desc":
        {
          event.target.classList.remove("fa-sort-up");
          event.target.classList.add("fa-sort-down");
          this.oldField = field;
        }
        break;
      case "asc":
        {
          event.target.classList.remove("fa-sort-down");
          event.target.classList.add("fa-sort-up");
          this.oldField = field;
        }
        break;
      default: {
        event.target.classList.add("fa-sort");
      }
    }

    this.sortingData = {
      field: this.sortField,
      type: this.sortType,
    };

    this.getPageRequest();
  }

  //this function delete Order(soft delete);
  deleteOrder(id, orderNo) {
    $("#deleteSpinner_" + id).removeClass("hidden");
    swal({
      title: "Are you sure?",
      text: "You want to Delete Order No: " + orderNo,
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#163862",
      cancelButtonColor: "rgb(245, 54, 92)",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.value == true) {
        const routePath = "delete-order";
        let token = this._services.getToken();

        var data = {
          client_id: this.orderData.clientId,
          order_id: id,
          page: this.currentPage,
          search: {
            client_name: this.searchFields["client_name"],
            order_no_unique: this.searchFields["order_no_unique"],
          },
          sort: this.sortingData,
        };

        this._services
          .postRequest(data, routePath, token)
          .subscribe((data: any) => {
            this.getSearchRequest();
            swal({
              title: 'Success',
              text: 'The order has been deleted successfully',
              type: 'success',
              showCancelButton: false,
              confirmButtonColor: "rgb(17, 205, 239)",
              cancelButtonColor: "rgb(245, 54, 92)",
              confirmButtonText: "Yes"
            });
          }, error => {
            swal({
              title: 'Error',
              text: 'The order could not be deleted: ' + error.error.message,
              type: 'error',
              showCancelButton: false,
              confirmButtonColor: "rgb(17, 205, 239)",
              cancelButtonColor: "rgb(245, 54, 92)",
              confirmButtonText: "Yes"
            });
          });
      } else {
        $("#deleteOrder_" + id).addClass("hidden");
      }
    });
  }

  searchProjectOrder(event) {
    this.searchProjectId = event.value[0].id ? event.value[0].id : 1;
    // this.getPageRequest();
  }

  showOrderInfo(order: any) {
    const orderData = new OrderData({
      id: order.order_id,
      reference: order.reference,
      status: order.order_status,
      project_order_id: order.project_order_id,
      clientId: order.client_id
    })
    this.viewOrder.emit(orderData);
  }

  toggleCollapse(order: any): void {
    order.collapsed = !order.collapsed;
  }

}